import { gql } from '@apollo/client';

export const VANITY_ITEM_OWNERSHIP_STATS = gql`
  query VanityItemOwnershipStats(
    $category: VanityItemCategory!
    $vanityItemIdPrefix: String!
    $activeDays: Int
  ) {
    vanityItemOwnershipStats(
      category: $category
      vanityItemIdPrefix: $vanityItemIdPrefix
      activeDays: $activeDays
    ) {
      category
      vanityItemIdPrefix
      totalUsers
      activeUsers
      activeDays
      computedAt
    }
  }
`;
